import { render } from "./MainComponent.vue?vue&type=template&id=5bfee68f"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import "./MainComponent.vue?vue&type=style&index=0&id=5bfee68f&lang=css"

import exportComponent from "C:\\Users\\kimjiwon\\Desktop\\테스트사이트\\메인페이지\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__